import type { Ref } from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { flexbox, gridGap } from 'styled-system';

import { Box } from '@/components/Box';

import type { FlexProps } from './props';

export const Flex = forwardRef((props: FlexProps, ref: Ref<HTMLElement>) => {
  const { as, ...rest } = props;
  return <StyledFlex ref={ref} forwardedAs={as} {...rest} />;
});

Flex.displayName = 'Flex';

Flex.defaultProps = {
  as: 'div',
};

const StyledFlex = styled(Box)<FlexProps>`
  display: ${({ inline }) => (inline ? 'inline-flex' : 'flex')};
  ${flexbox};
  ${gridGap};
`;
